import React, { useEffect, useState } from "react";
import { Box, Text, Accordion, AccordionItem, AccordionButton, AccordionPanel, AccordionIcon, Select, useToast} from "@chakra-ui/react";
import { Avatar } from "rsuite";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import SpinnerLoader from "components/Spinner/SpinnerLoader";
import { GoPencil } from "react-icons/go";
import ClientProject from "components/allForm/clientProject/clientProject";
import { fetchAsyncGetClientByID,fetchAsyncGetClientGraphOverview } from "redux/clientProjectSlice";
import ClientBarChart from "./clientBarChart";
import { generateYearOptions } from "views/admin/default/components/filterOption";
import GetAddress from "components/GetAddress";
import { getAccountType } from "components/allForm/Vendors/customFieldData";

const {yearOption,defaultSelected} = generateYearOptions();
const months = ["Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec", "Jan", "Feb", "Mar"];

const getMonthsForYear = (year) => {
  const yearStart = parseInt(year.split("-")[0]); 
  const yearEnd = parseInt(year.split("-")[1]);   

  let startMonthIndex, endMonthIndex, xAxisLabel;
  startMonthIndex = 0; 
  endMonthIndex = 11; 
  xAxisLabel = `${year.split("-")[0]} to ${year.split("-")[1]}`;
  const monthRange = months.slice(startMonthIndex, endMonthIndex + 1).map((month, index) => {
      const monthYear = index < 9 ? yearStart : yearEnd; 
      return `${month}-${monthYear}`;
  });
  return { monthRange, xAxisLabel };
};

const ProjectOverview = ({activeTab,projectOptions}) => {
  const { id } = useParams();  
  const currUser = useSelector((state) => state.auth.currUser);
  const addToast = useToast()
  const dispatch = useDispatch();
  const [projectId,setProjectId] = useState(null);
  const [revenueData,setRevenueData] = useState([0,0,0,0,0,0,0,0,0,0,0,0])
  const [loading, setLoading] = useState(false); 
  const [role,setRole] = useState('')  
  const [clientDetails,setClientDetails] = useState({})
  const [selectedYear, setSelectedYear] = useState(defaultSelected); 
  const { monthRange } = getMonthsForYear(selectedYear);
  const chartOptions = {xaxis: { categories: monthRange}};
  const [openClientModal, setOpenClientModal] = useState(false);

  useEffect(()=>{
    if(currUser && currUser?.auth){

      const auth = currUser?.auth;
      const roleObj = auth && auth?.length > 0 && auth.find((item)=> item?.module === 'Client Project');
      if(roleObj){
        setRole(roleObj?.access)
      }
    }
  },[currUser])

   const fetchClientDetails = async (clientId) => {
    try {
      const res = await dispatch(fetchAsyncGetClientByID(clientId)); 
      if (res?.payload) {
        const client = res.payload.client
        setClientDetails(client);
      }
    } catch (error) {
      addToast(`Error fetching client details:`, { appearance: "error" });
    } 
  };

  const getClientFinancialGraphOverview = (id,financialYear)=>{
    setLoading(true); 
    dispatch(
      fetchAsyncGetClientGraphOverview({
        clientId: id,
        projectId:projectId,
        financialYear:financialYear
        }
      )
    ).then((res) => {
      if (res.payload) {
        const data = res.payload || [];
        const amountArray = data.map((item)=> item?.totalAmount)
        setRevenueData(amountArray)
      } else {
        addToast(`Error fetching graph ovrview!:`, { appearance: "error" });
      }
    }).finally(() => {
      setLoading(false);
    });
  }


  useEffect(() => {
    if (id && activeTab === 'overview') {
      fetchClientDetails(id);
      getClientFinancialGraphOverview(id,selectedYear)
    }
  }, [id,projectId,selectedYear,activeTab]); 

 
  const handleOpenClientModal = () => {
    setOpenClientModal(true);
  };


  const handleCloseClientModal = () => {
    setOpenClientModal(false);
    fetchClientDetails(id);
  };

  
  if (loading) { return (<SpinnerLoader/>);}

  return (
    <>
      <Box display="flex" className="mx-0 vendor_details">
        <Box className="overview_details_sidebar">
          <Box className="all-vendor mx-2">
            <Text className="all-vendor-text">
              {clientDetails?.clName}{" "}
              <button
                className="vendor-edit-btn mt-1"
                onClick={handleOpenClientModal}
              >
                <GoPencil fontWeight={600} />
              </button>
            </Text>
          </Box>
          <Box display="flex" className="vendor-avtar mt-4 mx-0">
            <Avatar name="Sage Adebayo" shape="rounded" size="22" />
            <Box>
              <Text className="mx-3" fontWeight="600">
                {clientDetails?.clName}
                <Text color="#408DFB" fontSize="11px">Email: {clientDetails?.mail} </Text>

              </Text>
            </Box>
          </Box>
          <Box className="acordian-box mt-3">
          <Accordion defaultIndex={[0]} allowMultiple>
              <AccordionItem borderTop="none">
                <h2>
                  <AccordionButton>
                    <Box flex="1" textAlign="left">
                      <Text fontWeight="600">Personal Details</Text>
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                </h2>
                <AccordionPanel className="acordian-panal px-0">
                  <Box display="flex" justifyContent="space-between" mb={2}>
                    <Text color="#6C7184">Company Name </Text>
                    <Text className="mt-0 text2" fontWeight={500} color="#000">{clientDetails?.clName}</Text>
                  </Box>
                 
                  <Box display="flex" justifyContent="space-between" mb={2}>
                    <Text color="#6C7184">Phone</Text>
                    <Text className="mt-0 text2" fontWeight={500} color="#000000">{clientDetails?.ph ? clientDetails?.ph :'-'}</Text>
                  </Box>
                 
                  <Box display="flex" justifyContent="space-between" mb={2}>
                    <Text color="#6C7184">Email</Text>
                    <Text className="mt-0 text2" fontWeight={500} color="#000000">{clientDetails?.mail}</Text>
                  </Box>
                
                </AccordionPanel>
                </AccordionItem>
                <AccordionItem borderTop="none">
                <h2>
                  <AccordionButton>
                    <Box flex="1" textAlign="left">
                      <Text fontWeight="600">Address</Text>
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                </h2>
                <AccordionPanel className="acordian-panal px-0">
                  <Box display="flex" flexDirection="column">
                      <Box flex="1" textAlign="left">
                        <Text fontWeight="600" color="#6C7184">Billing Address</Text>
                      </Box>
                    <GetAddress address={clientDetails?.add} color="#6C7184" />
                    <Text color="#6C7184">{clientDetails?.add?.ph ? `Phone: ${clientDetails?.add?.ph || "-"}` :""}</Text>
                    <Text color="#6C7184">{clientDetails?.add?.mail ? `Email: ${clientDetails?.add?.mail || "-"}` :''}</Text>
                  </Box>
                </AccordionPanel>
                <AccordionPanel className="acordian-panal px-0">
                  <Box display="flex" justifyContent="space-between" flexDirection="column">
                        <Box flex="1"  textAlign="left">
                          <Text fontWeight="600" color="#6C7184">Shipping Address</Text>
                        </Box>
                        <GetAddress address={clientDetails?.spAd} color="#6C7184" />

                    <Text color="#6C7184">{clientDetails?.spAd?.ph ? `Phone: ${clientDetails?.spAd?.ph || "-"}` :""}</Text>
                    <Text color="#6C7184">{clientDetails?.spAd?.mail ? `Email: ${clientDetails?.spAd?.mail || "-"}` :''}</Text>
                  </Box>
                 
                
                </AccordionPanel>
                </AccordionItem>
                <AccordionItem borderTop="none">
                <h2>
                  <AccordionButton>
                    <Box flex="1" textAlign="left">
                      <Text fontWeight="600">Tax Details</Text>
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                </h2>
                <AccordionPanel className="acordian-panal px-0">
                  
                <Box display="flex" justifyContent="space-between" mb={2}>
                    <Text color="#6C7184">GST Number</Text>
                    <Box display="flex" flexDirection="column">

                    {clientDetails?.gsts && clientDetails?.gsts?.length ?
                    clientDetails?.gsts.map((item,i)=>{
                      return(
                        <>
                        <Text className="mt-1 text2" fontWeight={500} color="#000000">{i+1}. {item?.gstNo}</Text>
                        <Text className="mt-1 mx-3 text2" fontWeight={500} color="#000000">{item?.pos ? item?.pos : ""}</Text>
                        </>

                      )
                    })
                    :
                    <Text className="mt-0 text2" fontWeight={500} color="#000000">{clientDetails?.gstNo}</Text>
                    }
                    </Box>
                  </Box>

                  <Box display="flex" justifyContent="space-between" mb={2}>
                    <Text color="#6C7184">PAN Number</Text>
                    <Text className="mt-0 text2" fontWeight={500} color="#000000">{clientDetails?.pnNo}</Text>
                  </Box>
                </AccordionPanel>
              </AccordionItem>
                </Accordion>
          </Box>
          <Box className="acordian-box mt-3">
            <Accordion defaultIndex={[0]} allowMultiple>
              <Text fontWeight="600" fontSize="14px" mt={8} mb={2}>
                Project Details
              </Text>
              {clientDetails?.prjs &&
                clientDetails?.prjs?.length > 0 &&
                clientDetails?.prjs?.map((item, i) => {
                  return (
                    <AccordionItem borderTop="none">
                      <h2>
                        <AccordionButton>
                          <Box flex="1" textAlign="left">
                            <Text fontWeight="600">{item?.prj}</Text>
                          </Box>
                          <AccordionIcon />
                        </AccordionButton>
                      </h2>
                      <AccordionPanel className="acordian-panal px-0">
                        <Box display="flex" flexDirection="column" mb={3}>
                          <Box
                            display="flex"
                            justifyContent="space-between"
                            mb={2}
                          >
                            <Text color="#6C7184">Project Name </Text>
                            <Text
                              className="mt-0 text2"
                              fontWeight={500}
                              color="#000000"
                            >
                              {item?.prj ? item?.prj : "-"}
                            </Text>
                          </Box>
                        </Box>
                      </AccordionPanel>
                    </AccordionItem>
                  );
                })}
                <Text fontWeight="600" fontSize="14px" mt={8} mb={2}>Client Bank Details</Text>
              {clientDetails?.bnkDtl && clientDetails?.bnkDtl?.length > 0 && clientDetails?.bnkDtl?.map((item,i)=>{
                return (
                  <AccordionItem>
                  <h2>
                    <AccordionButton>
                      <Box flex="1" textAlign="left">
                        <Text fontWeight="600">{item?.bnk}  Detail</Text>
                      </Box>
                      <AccordionIcon />
                    </AccordionButton>
                  </h2>
                  <AccordionPanel className="acordian-panal px-0">
                    
                    <Box display="flex" flexDirection="column" mb={3}>
                      
                        <Box display="flex" justifyContent="space-between" mb={2}>
                          <Text color="#6C7184">Account Holder Name </Text>
                          <Text className="mt-0 text2" fontWeight={500} color="#000000">{item?.hol ? item?.hol : clientDetails?.clName}</Text>
                        </Box>
                        <Box display="flex" justifyContent="space-between" mb={2}>
                          <Text color="#6C7184">Account Number </Text>
                          <Text className="mt-0 text2" fontWeight={500} color="#000000">{item?.acNo}</Text>
                        </Box>
                        <Box display="flex" justifyContent="space-between" mb={2}>
                          <Text color="#6C7184">IFSC Code </Text>
                          <Text className="mt-0 text2" fontWeight={500} color="#000000">{item?.ifc}</Text>
                        </Box>
                        <Box display="flex" justifyContent="space-between" mb={2}>
                          <Text color="#6C7184">Account Type </Text>
                          <Text className="mt-0 text2" fontWeight={500} color="#000000">{getAccountType(item?.typ)}</Text>
                        </Box>
                        <Box display="flex" justifyContent="space-between" mb={2}>
                          <Text color="#6C7184">Bank Name</Text>
                          <Text className="mt-0 text2" fontWeight={500} color="#000000">{item?.bnk}</Text>
                        </Box>
                        <Box display="flex" justifyContent="space-between" mb={2}>
                          <Text color="#6C7184">SWIFT Code</Text>
                          <Text className="mt-0 text2" fontWeight={500} color="#000000">{item?.swt}</Text>
                        </Box>
                        <Box display="flex"   justifyContent="space-between" mb={3}>
                          <Text color="#6C7184">Branch Name</Text>
                          <Text className="mt-0 text2" fontWeight={500} color="#000000">{item?.bch}</Text>
                        </Box>
                        <Box flex="1" mb={3} textAlign="left">
                          <Text fontWeight="600" color="#6C7184">Bank Address</Text>
                        </Box>
                        <Box display="flex" justifyContent="space-between" mb={2}>
                          <Text color="#6C7184">City</Text>
                          <Text className="mt-0 text2" fontWeight={500} color="#000000">{item?.bAd?.ct}</Text>
                        </Box>
                        <Box display="flex" justifyContent="space-between" mb={2}>
                          <Text color="#6C7184">State</Text>
                          <Text className="mt-0 text2" fontWeight={500} color="#000000">{item?.bAd?.st}</Text>
                        </Box>
                    
                    </Box>
  
                   
                    
                  </AccordionPanel>
                </AccordionItem>
                )
              })}
            </Accordion>
          </Box>
        </Box>

        <Box className="vendor_details_main mt-5 mx-2">
          <Box display="flex" className="mb-3 ">
           
            <Select
              className="mx-3 client-details-select-field"
              width="150px"
              value={selectedYear}
              onChange={(e) => setSelectedYear(e.target.value)}
            >
              {yearOption.map((year) => (
                <option key={year.value} value={year.value}>
                  {year.label}
                </option>
              ))}
            </Select>
            <Select
              className="mx-4 client-details-select-field"
              width="180px"
              value={projectId}
              onChange={(e) => setProjectId(e.target.value)}
            >
              <option value="">Select Project</option>
              {projectOptions.map((prj) => (
                <option key={prj.value} value={prj.value}>
                  {prj.label}
                </option>
              ))}
            </Select>
           
          </Box>
         
            <Text className="mx-3">
              <strong>Amount</strong> - Total Payments Made to Client for This
              Project
            </Text>
         
          <Box mt={3} height={400}>
            <ClientBarChart
              chartData={[{ name: "Revenue", data: revenueData }]}
              chartOptions={chartOptions}
            />
          </Box>
        </Box>
      </Box>
      {openClientModal && (
        <ClientProject
          openModal={openClientModal}
          closeModal={handleCloseClientModal}
          isEditForm={openClientModal}
          editItem={clientDetails}
          role={role}
        />
      )}
    </>
  );
};

export default ProjectOverview;
